// 📁 src/redux/slices/dateOptionsSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

// ✅ Types
interface DateOption {
  label: string;
  value: string;
}

interface FetchDateParams {
  page?: number;
  limit?: number;
  searchTerm?: string | null |any;
 DATE?: any;         // changed to any
  TITLE?: any;
  FILE_NAME?: any;
}


interface DateOptionsState {
  FilenameOption: any;
  loadingOfFile: boolean;
  error: string | null;
  hasMore: boolean;
  currentPage: number;
  limit:number;
  ToselectFileName:boolean;
}

// ✅ Initial State
const initialState: DateOptionsState = {
  FilenameOption: [],
  loadingOfFile: false,
  error: null,
  hasMore: true,
  currentPage: 1,
limit:10,
  ToselectFileName:false,
};

export const FetchFileNameOptions = createAsyncThunk(
  "FetchFileNameOptions",
   async (params: FetchDateParams = {}, { rejectWithValue }) => {
    console.log("page in reducer", params);
    try {
      const queryParams: string[] = [];

      if (params.page !== undefined) queryParams.push(`page=${params.page}`);
      if (params.limit !== undefined) queryParams.push(`limit=${params.limit}`);
      if (params.searchTerm !== undefined)queryParams.push(`searchTerm=${params.searchTerm}`);
      // if (params.DATE?.length) queryParams.push(`DATE=${params.DATE}`);
       if (Array.isArray(params.DATE)) {
        params.DATE.forEach(date => {
          queryParams.push(`DATE=${encodeURIComponent(date)}`);
        });
      }
        if (Array.isArray(params.TITLE)) {
        params.TITLE.forEach(title => {
          queryParams.push(`TITLE=${encodeURIComponent(title)}`);
        });
      }
        if (Array.isArray(params.FILE_NAME)) {
        params.FILE_NAME.forEach(file => {
          queryParams.push(`FILE_NAME=${encodeURIComponent(file)}`);
        });
      }
      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await axios.get(
        `${API.GETFILENAMEOPTIONSINKDD}${queryString}`
      );

      return { data: response.data, page: params.page ?? 1 };
    } catch (err: any) {
      if (err.response?.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

// ✅ Slice
const dateOptionsSlice = createSlice({
  name: "dateOptions",
  initialState,
  reducers: {
    clearDateOptions: (state) => {
      state.FilenameOption = [];
      state.currentPage = 1;
      state.hasMore = true;
      state.loadingOfFile = false;
      state.error = null;
    },
    setToselectFileName: (state, action: PayloadAction<boolean>) => {
      state.ToselectFileName = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
       .addCase(FetchFileNameOptions.pending, (state) => {
        state.loadingOfFile = true;
        // state.status = "loadingOfFile";
      })
      .addCase(FetchFileNameOptions.fulfilled, (state, action) => {
        const { data, page } = action.payload;
        const filedata = (data.file_name_options || []).map((item: string) => ({
          label: item,
          value: item,
        }));
        console.log(filedata, "filedata");
        if (page === 1) {
          state.FilenameOption = filedata;
        } else {
          state.FilenameOption = [...state.FilenameOption, ...filedata];
        }

        state.currentPage = page;
        state.hasMore = data.hasMore;
        state.loadingOfFile = false;
      })
      .addCase(FetchFileNameOptions.rejected, (state) => {
        state.loadingOfFile = false;
        // state.status = "Failed";
        state.error = "Error";
      });
  }
});

// ✅ Export Actions and Reducer
export const { clearDateOptions,setToselectFileName} = dateOptionsSlice.actions;
export default dateOptionsSlice.reducer;
